<template>
    <button type="button"
        class="mead-app-sidebar-rail-item f fa-c fj-c c-p br-m"
        :class="[
            active ? 'el--active' : '',
            hovered ? 'el--hovered' : '',
            item.upsell ? 'el--upsell' : '']"
        :qa="uiQa"
        :disabled="item.disabled"
        :aria-label="uiLabel"
        :aria-current="active ? 'page' : null"
        @click="$emit('click', item)"
        @mouseenter="$emit('hover', $event)">
        <mead-icon :name="item.getIcon(active)" uiSize="xl" />
        <mead-badge v-if="uiHasBadge" :lbl="item.badge" class="mead-app-sidebar-rail-item-badge" />
    </button>
</template>

<script>
export default {
    name: 'mead-app-sidebar-rail-item',
    props: {
        /**
         * The top level `MeadCommon.AppSidebarItem` this icon represents.
         */
        item: {type: Object, required: true},
        /**
         * Highlights the icon as the selected section. Swaps in the item's focus icon when the item has one.
         */
        active: {type: Boolean, default: false},
        /**
         * Keeps the hover style while the item's popover is open.
         */
        hovered: {type: Boolean, default: false},
    },
    computed: {
        uiHasBadge: function () {
            return this.item.hasBadge;
        },
        uiLabel: function () {
            return MeadCommon.I18N.go(this.item.label);
        },
        uiQa: function () {
            return this.item.hasQATag ? this.item.qa_tag : `app-sidebar-rail-item-${this.item.uid}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../../../sass/variables' as *;

.mead-app-sidebar-rail-item {
    position: relative;
    width: 4.4rem;
    height: 4.4rem;
    //  Set here, not with a utility class, as this scoped rule would override the class
    margin: 0 0 $s-xs 0;
    border: none;
    background-color: transparent;
    color: var(--c-sidebar-rail-fg);
    transition: background-color .2s ease;

    &:hover,
    &.el--hovered {
        background-color: var(--c-sidebar-rail-bg-hover);
    }

    &.el--active {
        background-color: var(--c-sidebar-rail-bg-active);
        color: var(--c-sidebar-rail-fg-active);
    }

    &:focus-visible {
        outline: 2px solid var(--c-sidebar-rail-fg);
        outline-offset: 1px;
    }

    &.el--upsell,
    &:disabled {
        opacity: .5;
        cursor: not-allowed;
    }

    &:disabled:hover {
        background-color: transparent;
    }

    .mead-app-sidebar-rail-item-badge {
        position: absolute;
        top: -.4rem;
        right: -.4rem;
    }

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
}
</style>
